import {
  IconApiApp,
  IconChartBar,
  IconCreditCardHand,
  IconSourceCode,
  IconUserCircle,
  IconWallet,
} from "@tabler/icons-react";

import { ROUTES } from "@/app/router/routes";

import type { MenuItem } from "./type";

export const DEFAULT_PAGE_LABEL = "پیشخوان";

export const MENU_ITEMS: MenuItem[] = [
  {
    label: "پروفایل",
    path: ROUTES.PROFILE,
    icon: IconUserCircle,
  },
  {
    label: "پرداخت‌های من",
    path: ROUTES.PAYMENTS,
    icon: IconCreditCardHand,
  },
  {
    label: "شارژ کیف پول",
    path: ROUTES.WALLET_TOP_UP,
    icon: IconWallet,
  },
  {
    label: "گزارش‌گیری",
    path: ROUTES.REPORTS,
    icon: IconChartBar,
  },
  {
    label: "توسعه‌دهندگان",
    path: ROUTES.DEVELOPERS,
    icon: IconSourceCode,
  },
  {
    label: "کسب و کارهای من",
    path: ROUTES.MY_BUSINESSES,
    icon: IconApiApp,
  },
  // {
  //   label: "لیست خروجی‌های اکسل",
  //   path: ROUTES.EXCEL_EXPORTS,
  //   icon: IconFileExcel,
  // },
];
